










































































































import {Component, Vue} from "vue-property-decorator";
import userApi from "@/api/userApi";
import User from "@/model/user";
import qNotify from "@/common/qNotify";
import store from "@/store";
import {namespace} from "vuex-class";
const authStore = namespace("Auth");

@Component({
  name: "AccountDetail",
})

export default class AccountDetail extends Vue {
  public isShow = false;
  @authStore.Getter
  getUserLogging!: User

  get user() {
    return new User(store.state.User.user) ;
  }

  public show() {
    this.isShow = true;
  }

  public cancel() {
    this.$emit('refreshUserList');
    this.isShow = false;
  }

  public editCooperate(userCompany, cooperateIndex) {
    const userCompanyCooperation = {
      id: userCompany.id,
      role_id: userCompany.role_id,
      company_id: userCompany.company_id,
      affiliation_company_id: userCompany.affiliation_company_id,
      company_name: userCompany.company.name,
      user_id: userCompany.user_id,
      user_name: this.user.username,
    };
    this.$emit('editCooperate', {
      userCompanyCooperation: userCompanyCooperation,
      cooperateIndex: cooperateIndex
    });
  }

  public deleteCooperate(userCompany, index) {
    this.$modal.showDelete({
      text: this.$t("users.delete_cooperation", { user_name: this.user.username}),
      confirmText: this.$t("confirm_text.yes"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await userApi.deleteCooperate(userCompany.id);
        if (result.meta.status === 200) {
          qNotify.success({
            text: this.$t("users.cooperation_deleted"),
          });
          store.dispatch("User/spliceCooperate", index);
        } else {
          qNotify.error({
            text: this.$t(result.meta.message),
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public deleteUser() {
    this.$modal.showDelete({
      text: this.$t("delete"),
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        const result = await userApi.deleteUser(this.user.id);
        if (result.status === 200) {
          this.isShow = false;
          this.$emit('refreshList');
          qNotify.success({
            text: this.$t("users.deleted"),
          });
        } else {
          qNotify.error({
            text: result.data.message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }
}
